<template>
    <div class="titleName">
        <div>

        </div>
        {{TitleName}}
    </div>
</template>

<script>
export default {
    props:['TitleName']
}
</script>

<style lang="scss" scoped>
    .titleName{
        border-left: 4px solid rgb(18, 139, 237);
        padding-left: 8px;
        color: rgb(18, 139, 237);
        margin-top: 20px;
        font-size: 14px;
        margin-bottom: 10px;
        font-weight: 600;
    }
</style>